<section id="new-car" class="section-padding">
  <div class="bgEffect">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-6">
        <div class="new-car-left clearfix">
          <img class="sifirkm" src="assets/img/shared/sifirkm.png" alt="">
          <div class="sifirkm-content">
            <span>Türkiye'nin</span>
            <span>En Güncel</span>
            <a href="#" class="btn btn-s btn-primary">0 Km Araç Fiyatları</a>
          </div>

          <svg id="triangle" viewBox="0 0 49 197" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Anasayfa" transform="translate(-796.000000, -957.000000)" fill="#2A3238">
                <polygon id="Triangle" points="845 957 796 957 796 1154"></polygon>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="col-lg-6 col-md-6">
        <div class="new-car-right">
          <div class="car-vs-content">
            <img src="assets/img/shared/car-vs.png" alt="">
            <div class="sifirkm-content">
              <span>Türkiye'nin</span>
              <span>En Kapsamlı</span>
              <a href="#" class="btn btn-s btn-primary">Araç Karşılaştırması</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 tac">
        <a [routerLink]="['/contact']" class="btn btn-primary btn-m">Detaylı Bilgi için İletişime Geçin</a>
      </div>
    </div>
  </div>
  </div>
</section>